module.exports = __webpack_public_path__ + "img/pruefening_presbyterium_fresken_2014_ref.b3965ef2.jpg";